import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
// import CompOptions from "./competenciesoptions";
import CompetencyOptions from "./CompetencyOptions";

const styles = {
  searchUser__block: {
    background: "#fff",
    position: "relative",
    top: "1px"
  }
};

class CompSelect extends Component {
  constructor (props) {
    super(props);
    
  }

  state = {
    name: ""
  };

  handleChangeValue = (id, name) => {
    this.setState(
      preState => ({
        ...preState,
        cid: id,
        name: name,
      }),
      function() {
        //this.props.handleCompetency(target.value.cid, target.value.name);
        this.props.handleCompetency(id, name);
      }
    );
  };

  render() {
    const { classes, competencyid } = this.props;
     return (
       <CompetencyOptions filterMode={this.props.filterMode} dailyThoughtType={this.props.dailyThoughtType} onChangeValue={this.handleChangeValue} competencyid={competencyid} />
    );
  }
}

export default withStyles(styles)(CompSelect);
